module.exports = __webpack_public_path__ + "cefbc0968a9dadca1b88b37a8dea4a9b.svg";